import React, { useState } from 'react'
import { Button } from 'primereact/button';
import { Editor } from 'primereact/editor';

const Terms = ({termsConditions, addEstablishmentInfo}) => {

  const [text1, setText1] = useState(termsConditions);
  const [loading, setLoading] = useState(false)
  
  const onSauvegarderClicked = async () => {
    setLoading(true)
    await addEstablishmentInfo({ termsConditions: text1 })
    setLoading(false)
  }

  return (
    <div className="col-12 lg:col-6 xl:col-6">
    <div className="card p-fluid">
    <p className='mb-4 font-semibold'>terms et conditions</p>
    <Editor style={{ height: '320px' }} 
    value={text1} 
    onTextChange={(e) => setText1(e.htmlValue)} />
    <div className='mt-3 flex justify-content-end'>
        <Button 
        loading={loading} 
        disabled={loading}
        label='sauvegarder'
        icon="pi pi-check"
        className='w-auto' 
        onClick={() => onSauvegarderClicked()} 
        />
    </div>
    </div>
    </div>
  )
}

export default Terms